import React from 'react';
import Modal from '@material-ui/core/Modal';
import styles from '../../../Pages/OptionsBoard/OptionsBoardStyles';
import {
  DataBox1,
  DataBox2,
  DataBox3,
  HomePageTable1,
  HomePageTable2,
  HomePageTable3,
  VolumeText,
  WatchListAdd,
  WatchListTable,
} from '../../../Pages/Stock/constants';

const ToolTipModal = ({
  showModal,
  isMobile,
  clickHandler,
  type,
  onCloseHandler,
}) => {
  const RenderData = (type) => {
    switch (true) {
      case type === 'databox1':
        return DataBox1;

      case type === 'databox2':
        return DataBox2;

      case type === 'databox3':
        return DataBox3;

      case type === 'volume':
        return VolumeText;

      case type === 'hometable1':
        return HomePageTable1;

      case type === 'hometable2':
        return HomePageTable2;

      case type === 'hometable3':
        return HomePageTable3;

      case type === 'watchlistadd':
        return WatchListAdd;

      case type === 'watchlisttable':
        return WatchListTable;

      default:
        return 'No Type Found';
    }
  };
  return (
    <div
      style={
        isMobile
          ? { width: '220px' }
          : { width: '200px', backgroundColor: 'black' }
      }
    >
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showModal}
        onClose={onCloseHandler}
      >
        <div
          style={
            isMobile
              ? styles.ToolTipboardModalContentMobile
              : styles.ToolTipboardModalContent
          }
        >
          <div
            onClick={clickHandler}
            style={
              !isMobile
                ? {
                    ...styles.modalCloseButtonWatchlistModal,
                    marginTop: '2px',
                  }
                : {
                    ...styles.modalCloseButtonWatchlistMobile,
                    marginTop: '2px',
                  }
            }
          >
            X
          </div>

          {RenderData(type)}
        </div>
      </Modal>
    </div>
  );
};

export default ToolTipModal;



// WEBPACK FOOTER //
// ./src/components/Modals/ToolTip Modal/index.js